import { render, staticRenderFns } from "./boutique.vue?vue&type=template&id=02b9af21&scoped=true"
import script from "./boutique.vue?vue&type=script&lang=js"
export * from "./boutique.vue?vue&type=script&lang=js"
import style0 from "./boutique.vue?vue&type=style&index=0&id=02b9af21&prod&lang=scss&scoped=true"
import style1 from "./boutique.vue?vue&type=style&index=1&id=02b9af21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b9af21",
  null
  
)

export default component.exports